import { Alert, AlertIcon, Box, Stack, Text } from '@chakra-ui/react';
import { PiIdentificationBadgeFill } from 'react-icons/pi';
import InputMobile from '../../../../../../components/Input/Mobile';
import TitleSectionMobilePage from '../../../../../../components/Mobile/titleSection';
import { FieldValues, useFormContext } from 'react-hook-form';
import { useState } from 'react';
import { createFileCopy } from '../../../../../../utils/functions';
import BoneMarrowUploadFields from '../../../Forms/MarrowDonnor/BoneMarrowUploadFields';

const BloodDonorFormMobile: React.FC<{ redomeCodeRequired: boolean }> = ({ redomeCodeRequired }) => {
  const accent = '#222';
  const { getValues, setValue, trigger, formState } = useFormContext<FieldValues>();
  const initialFiles = getValues('attachmentExemption') as File[] | undefined;
  const [selectedFiles, setSelectedFiles] = useState<(File | undefined)[]>(() => [
    initialFiles?.[0],
    initialFiles?.[1],
    initialFiles?.[2],
  ]);

  const updateFile = async (index: number, file?: File) => {
    const selectedFile = file ? ((await createFileCopy(file)) as File) : undefined;
    const updatedSlots = [...selectedFiles];
    updatedSlots[index] = selectedFile;
    setSelectedFiles(updatedSlots);
    const files = updatedSlots.filter((item): item is File => item !== undefined);

    setValue('attachmentExemption', files, { shouldDirty: true, shouldTouch: true, shouldValidate: true });
    await trigger('attachmentExemption');
  };

  return (
    <Stack spacing={4}>
      <InputMobile
        isRequired={redomeCodeRequired}
        name="redome_code"
        placeholderLabel="Código de validação do REDOME:"
        iconLeft={<PiIdentificationBadgeFill size={15} color={accent} />}
      />

      <Alert status="info">
        <AlertIcon />
        <Text>
          Informe acima o código de validação da sua declaração de doador de medula óssea emitida pelo REDOME,
          disponível no rodapé do documento.
        </Text>
      </Alert>

      <Box>
        <TitleSectionMobilePage border="none" mb={0} fontSize="13px" fontWeight="normal">
          Envio de documento comprobatório:
        </TitleSectionMobilePage>
        <BoneMarrowUploadFields
          files={selectedFiles}
          hasError={Boolean(formState.errors.attachmentExemption)}
          errorMessage={formState.errors.attachmentExemption?.message?.toString()}
          onSelectFile={updateFile}
          onRemoveFile={(index) => void updateFile(index)}
        />
      </Box>
    </Stack>
  );
};

export default BloodDonorFormMobile;
